module.exports = __webpack_public_path__ + "static/media/seats.6672f267.svg";